import { IncompleteUserSchema } from "../services/user";

/**
 * Right now [2025-20-01] there is only one country where it is possible to use the platform without
 * being a member of a company. And that country is Ireland.
 *
 * Otherwise, we would strictly fail the `getFirstCompany` call when no company was found.
 */

const getFirstIncompleteCompany = (user: IncompleteUserSchema) => {
  return user["can/app_metadata"]?.companies?.at(0);
};

export { getFirstIncompleteCompany };
